<template>
  <div class="company-sp-services">
    <div class="company-sp-services-title">
      {{ $t('sp.registration.company.services.title') }}
    </div>
    <company-s-p-services-form
      :value="spCompanyServicesInfo"
      @changed="formChanged"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { CHANGE_SP_COMPANY_SERVICES_INFO } from '@/store/spCompanyRegistration/actionTypes';
import CompanySPServicesForm from '@/components/spCompanyRegistration/CompanySPServicesForm.vue';

export default {
  name: 'SPCompanyServices',
  components: {
    CompanySPServicesForm,
  },
  computed: {
    ...mapGetters([
      'spCompanyServicesInfo',
    ]),
  },
  methods: {
    formChanged(data) {
      this.$store.dispatch(CHANGE_SP_COMPANY_SERVICES_INFO, data);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.company-sp-services {
  border-radius: $radius-sm;
  background-color: $white;
  padding: rem(50) rem(80) rem(35);
  box-shadow: 0 0 rem(4) 0 rgba(14, 31, 51, 0.13);
  flex: 0.7;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.company-sp-services-title {
  color: $auth-text-primary;
  font-family: $font-family-medium;
  font-size: rem(20);
  font-weight: 500;
  letter-spacing: 0;
  line-height: rem(24);
  padding-bottom: rem(5);
}
</style>
